import { SecurityGroupsEffects } from 'src/app/admin/security-groups/store/effects';
import { CloneUserEffects } from 'src/app/admin/clone-user/store/effects';
import { IntegrationMappingsEffects } from '../integration-mappings/state/integrations.mappings.effects';
import { IntegrationDashboardEffects } from '../integration-dashboard/state/integration-dashboard.effects';
import { IntegrationManagev2Effects } from '../integration-managev2/state/integration-managev2-config.effects';
import { IntegrationEventLogDetailsEffects } from '../integration-event-log-details/state/integration-event-log-details.effects';

export const AdminEffects = [
    ...SecurityGroupsEffects,
    ...CloneUserEffects,
    IntegrationMappingsEffects,
    IntegrationDashboardEffects,
    IntegrationManagev2Effects,
    IntegrationEventLogDetailsEffects
];
